// CoreUI Pro source references: /Users/guochunzhong/git/oss/coreui-pro/js/src/util/backdrop.js, /Users/guochunzhong/git/oss/coreui-pro/js/src/util/focustrap.js, /Users/guochunzhong/git/oss/coreui-pro/js/src/util/scrollbar.js
import BaseComponent from "./base_component"

const locks = new Set()
let bodyStyles

export default class BackdroppedComponent extends BaseComponent {
  lockScroll() {
    if (locks.has(this)) return
    if (!locks.size) {
      bodyStyles = { overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight }
      const width = window.innerWidth - document.documentElement.clientWidth
      if (width)
        document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + width}px`
      document.body.style.overflow = "hidden"
    }
    locks.add(this)
  }

  unlockScroll() {
    if (!locks.delete(this) || locks.size) return
    Object.assign(document.body.style, bodyStyles)
  }

  createBackdrop(className) {
    if (this.backdrop || this.config.backdrop === false) return
    this.backdrop = document.createElement("div")
    this.backdrop.className = `${className} fade`
    document.body.append(this.backdrop)
    this.generated.push(this.backdrop)
    this.listen(this.backdrop, "click", () => this.dismissBackdrop())
    this.backdrop.offsetHeight
    this.backdrop.classList.add("show")
  }

  dismissBackdrop() {
    if (this.config.backdrop === "static") this.emit("hidePrevented")
    else if (this.config.backdrop) this.hide()
  }

  activateFocusTrap() {
    this.focusAbort?.abort()
    this.focusAbort = new AbortController()
    const options = { signal: this.focusAbort.signal }
    this.element.focus({ preventScroll: true })
    const focusable = () =>
      [...this.element.querySelectorAll("a[href], button, input, select, textarea, [tabindex]")].filter(
        (element) => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length,
      )
    document.addEventListener(
      "focusin",
      (event) => {
        if (!this.element.contains(event.target)) (focusable()[0] || this.element).focus()
      },
      options,
    )
    this.element.addEventListener(
      "keydown",
      (event) => {
        if (event.key !== "Tab") return
        const items = focusable()
        if (
          !items.length ||
          (event.shiftKey && (event.target === items[0] || event.target === this.element)) ||
          (!event.shiftKey && event.target === items.at(-1))
        ) {
          event.preventDefault()
          ;(event.shiftKey ? items.at(-1) || this.element : items[0] || this.element).focus()
        }
      },
      options,
    )
  }

  releaseFocus(restore = true) {
    this.focusAbort?.abort()
    if (restore && this.previouslyFocused?.isConnected) this.previouslyFocused.focus({ preventScroll: true })
  }

  removeBackdrop() {
    this.generated = this.generated.filter((element) => element !== this.backdrop)
    this.backdrop?.remove()
    this.backdrop = null
  }

  dispose() {
    if (this.signal.aborted) return
    this.releaseFocus(false)
    this.unlockScroll()
    this.removeBackdrop()
    this.element.classList.remove("show", "showing", "hiding")
    for (const attribute of ["style", "role", "aria-modal", "aria-hidden"]) this.restoreAttribute(attribute)
    super.dispose()
  }
}
